import ModalForm from '../../shared/components/modal-form';

export default class InternshipCancelModal extends ModalForm {
  constructor() {
    super(...arguments);

    this.bindEvents();
  }

  handleFormSuccess() {
    this.formWasSuccessful = true;
    this.$element.modal('hide');
  }

  handleModalHide() {
    if (this.formWasSuccessful) {
      window.Turbolinks.reload({keepScrollPosition: true});
    }
  }
}
